import { render, staticRenderFns } from "./StudentPeiInfo.vue?vue&type=template&id=2fd68d96&scoped=true"
import script from "./StudentPeiInfo.vue?vue&type=script&lang=js"
export * from "./StudentPeiInfo.vue?vue&type=script&lang=js"
import style0 from "./StudentPeiInfo.vue?vue&type=style&index=0&id=2fd68d96&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd68d96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd68d96')) {
      api.createRecord('2fd68d96', component.options)
    } else {
      api.reload('2fd68d96', component.options)
    }
    module.hot.accept("./StudentPeiInfo.vue?vue&type=template&id=2fd68d96&scoped=true", function () {
      api.rerender('2fd68d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visitRegistry/components/StudentPeiInfo.vue"
export default component.exports